import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import UserCarouselCard from 'appSrc/components/User/UserCarouselCard';
import { UnderslungCarousel } from 'appSrc/components/UI/Carousels';
import PropTypes from 'prop-types';
import style from './styles/style.module.css';

const carouselOptions = {
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
        {
            breakpoint:840,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            },
        },
        {
            breakpoint:480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            },
        },
    ],
};

class UserCarousel extends PureComponent {
    render() {
        const { carousel } = this.props;
        const content = carousel.content || [];

        return (
            <div className={ `${ style.userCarousel } ${ this.props.className }`.trim() }>
                { content.length > 0 &&
                    <div className={ style.carouselWrapper }>
                        { carousel.title &&
                            <div className={ 'carousel-title-bar ' + style.carouselTitleBar }>
                                <h2>{ carousel.title }</h2>
                                { carousel.link_url &&
                                    <Link to={ carousel.link_url }>{ carousel.link_text || 'See All' }</Link>
                                }
                            </div>
                        }
                        <UnderslungCarousel carouselOptions={ carouselOptions }>
                            { content.map( ( item ) => {
                                return (
                                    <div className={ style.cardWrapper } key={ `user_carousel\-${ carousel.id }--user-${ item.userid }` }>
                                        <UserCarouselCard user={ item } />
                                    </div>
                                );
                            } ) }
                        </UnderslungCarousel>
                    </div>
                }
            </div>
        );
    }
}
UserCarousel.propTypes = {
    className: PropTypes.string,
    carousel: PropTypes.object,
};
UserCarousel.defaultProps = {
    className: '',
    carousel: {},
};

export default UserCarousel;
